import * as globalStyles from "./globals.module.scss"

export const theme = {
  ...globalStyles,
}
